import {
	formatExpiryBatchesText,
	normalizeDateKey,
} from '../../../common/utils/warehousing/formatExpiryBatchSummary';

export const normalizeBatchRows = (rows = [], timezone) => {
	return rows.map(row => ({
		id: row.id || row._id || null,
		quantity: Math.max(0, Math.round(Number(row.quantity ?? row.quantityOnHand) || 0)),
		expiryDate: normalizeDateKey(row.expiryDate, timezone) || '',
		receivedAt: row.receivedAt || null,
		expiryDateSource: row.expiryDateSource || null,
		supplierBatchCode: (row.supplierBatchCode || '').trim(),
	}));
};

export const getExpirySummaryText = (batches = [], timezone) => {
	return formatExpiryBatchesText(batches, {
		maxRows: 2,
		fallback: 'Not captured',
		timezone,
	});
};
